import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Chrome } from 'vue-color';
import ClickOutside from 'vue-click-outside';

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=" .container[data-v-73f82df6] { position: relative; } ul[data-v-73f82df6] { box-sizing: border-box; overflow-y: scroll; list-style: none; border: 1px solid rgba(0, 0, 0, .2); border-radius: 10px; padding: 10px; margin: 0; } li[data-v-73f82df6] { display: inline-flex; align-items: center; justify-content: center; padding: 5px; margin: 5px; width: 20px; height: 20px; text-align: center; border: 1px solid rgba(0, 0, 0, .2); border-radius: 50px; transition: all .2s ease-in-out; } li.reset[data-v-73f82df6] { transition: none; color: red; } li.reset[data-v-73f82df6]:hover, li.reset.selected[data-v-73f82df6] { transform: none; background-color: red; color: white; } li[data-v-73f82df6]:hover { background-color: #5a5a5a; color: white; cursor: pointer; transform: scale(2); border: 1px solid transparent; } li.selected[data-v-73f82df6] { transform: scale(2); background-color: #1f8aff; color: white; border: none; } input[data-v-73f82df6] { display: block; width: calc(100% - 10px); border: 1px solid rgba(0, 0, 0, .2); padding: 5px; border-radius: 10px; margin: 5px 0; font-size: 1rem; line-height: 1.5; color: #495057; background-clip: padding-box; background-color: transparent; transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out; } input[data-v-73f82df6]:focus { outline: none; } .search[data-v-73f82df6] { margin-bottom: 5px; position: relative; } .icon-preview[data-v-73f82df6] { cursor: pointer; border: 1px solid rgba(0, 0, 0, .2); padding: 10px; width: 40px; height: 40px; border-radius: 10px; } .btn[data-v-73f82df6] { color: white; width: 100%; vertical-align: middle; user-select: none; border: 1px solid transparent; padding: 5px; outline: none; box-shadow: 0 0 2px rgba(0, 0, 0, .3), 0 4px 8px rgba(0, 0, 0, .3); background-color: #bd2130; cursor: pointer; } .btn[data-v-73f82df6]:active { color: #fff; background-color: #900b18; } "; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();


library.add(fas, fab);
var VueIconPicker = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideColorPicker),expression:"hideColorPicker"}],staticClass:"search"},[_c('div',{on:{"click":function($event){_vm.toggleColorPicker($event);}}},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"icon-preview",style:({color:_vm.color.hex}),attrs:{"icon":_vm.icon.iconName}}):_vm._e()],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],domProps:{"value":(_vm.search)},on:{"keyup":_vm.scrollToSelected,"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value;}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.colorPickerPosition),expression:"colorPickerPosition"}],style:(_vm.colorPickerPosition)},[_c('chrome-picker',{model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v;},expression:"color"}}),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.color = {};}}},[_vm._v("Clear Color")])],1)]),_vm._v(" "),_c('ul',{ref:"list",style:({'height':_vm.height})},[_c('li',{class:[_vm.value ? null : 'selected','reset'],on:{"click":_vm.resetValue}},[_c('font-awesome-icon',{attrs:{"icon":"ban"},on:{"click":_vm.resetValue}})],1),_vm._v(" "),_vm._l((_vm.filteredIcons),function(filteredIcon,index){return _c('li',{key:index,class:_vm.isSelected(filteredIcon) ? 'selected' : null,on:{"click":function($event){_vm.icon = filteredIcon;}}},[_c('font-awesome-icon',{attrs:{"icon":[filteredIcon.prefix,filteredIcon.iconName]}})],1)})],2)])},staticRenderFns: [],_scopeId: 'data-v-73f82df6',
    name: "VueIconPicker",
    components: {
        FontAwesomeIcon: FontAwesomeIcon,
        'chrome-picker': Chrome
    },
    directives: {
        ClickOutside: ClickOutside
    },
    props: {
        value: null,
        height: {
            type: String,
            default: '300px'
        }
    },
    data: function () {
        return {
            search: '',
            icons: Object.assign({}, fas, fab),
            icon: null,
            color: {},
            colorPickerPosition: null,
            popupItem: null
        }
    },
    mounted: function () {
        var this$1 = this;

        this.popupItem = this.$el;
        try {
            this.icon = this.icons[Object.keys(this.icons).find(function (icon) { return this$1.icons[icon].iconName === this$1.value.name; })];
            this.color = {hex: this.value.color};
            this.scrollToSelected();
            // eslint-disable-next-line
        } catch (e) {
        }


    },
    computed: {
        filteredIcons: function () {
            var this$1 = this;

            return Object
                .keys(this.icons)
                .filter(function (key) { return key !== 'faFontAwesomeLogoFull' && this$1.icons[key].iconName.includes(this$1.search); })
                .map(function (key) { return this$1.icons[key]; });
        },

    },
    methods: {
        scrollToSelected: function () {
            try {
                this.$refs.list.getElementsByClassName('selected')[0].scrollIntoView();
                // eslint-disable-next-line
            } catch (e) {
            }
        },
        isSelected: function (icon) {
            return this.value && icon.iconName === this.value.name && this.value.type === 'fontawesome';
        },
        resetValue: function () {
            this.icon = null;
            this.color = {};
            this.colorPickerPosition = null;
        },
        toggleColorPicker: function (e) {
            this.colorPickerPosition = this.colorPickerPosition ? null : {
                position: 'absolute',
                zIndex: 9999,
                top: ((e.pageY) + "px"),
                left: ((e.pageX) + "px"),

            };
        },
        hideColorPicker: function () {
            this.colorPickerPosition = null;
        }
    },
    watch: {
        icon: function (value) {
            this.$emit('input', value ? Object.assign({}, this.value, {name: value.iconName, type: 'fontawesome'}) : null);
        },
        color: function (value) {
            var val = this.value;
            if (value.hex)
                { val.color = value.hex; }
            else
                { delete val.color; }
            this.$emit('input', val);
        }
    }
}

// Import vue component

// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) { return; }
    install.installed = true;
    Vue.component('vue-icon-picker', VueIconPicker);
}

// Create module definition for Vue.use()
var plugin = {
    install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

export default VueIconPicker;
export { install };
